import AuthenticationQueries from "./AuthenticationQueries";
import LanguageQueries from "./LanguageQueries";

export const cacheQueries = {
  ...AuthenticationQueries,
  ...LanguageQueries
};
